export default function FeatureListFactory($log, $http) {
  'ngInject';

  return {
    getFeatureList: function () {
      console.warn(
        'The FeatureList factory has been deprecated and will be removed from a future release.'
      );

      return $http.get('/aptitude/feature/list', { cache: true });
    }
  };
}
